module.exports = __webpack_public_path__ + "static/media/cq_editor_evidenziato.70db4776.svg";